import { useVisibleProfileNavigationItems } from '@features/profile/hooks/use-visible-profile-navigation-items/useVisibleProfileNavigationItems';
import * as React from 'react';
import { NavLink } from 'react-router-dom';

import styles from './ProfileSideDesktopNavigation.module.css';

const ProfileSideDesktopNavigation = React.memo((): React.ReactElement => {
  const visibleNavigationItems = useVisibleProfileNavigationItems();

  return (
    <div
      className={styles.menuLayout}
      data-heap-id="profile-side-desktop-navigation"
    >
      <div className={styles.actions}>
        {visibleNavigationItems.map((linkItem) => {
          return (
            <NavLink
              key={linkItem.path}
              data-heap-id={`profile-nav-${linkItem.heapId}`}
              to={linkItem.path}
              className={({ isActive }) =>
                `${styles.link} ${isActive ? styles.active : ''}`
              }
            >
              {linkItem.label}
            </NavLink>
          );
        })}
      </div>
    </div>
  );
});

ProfileSideDesktopNavigation.displayName = 'ProfileSideDesktopNavigation';

export { ProfileSideDesktopNavigation };
